import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import PdfBasicOptionsForm from '../../../../components/pdf/options/PdfBasicOptionsForm'
import Separator from '../../../../components/helpers/Separator'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'
import Sticky from '../../../../components/helpers/Sticky'
import { COLORS } from '@btime/constants'

const OptionsForm = () => {
  return (
    <Sticky>
      <SeparatorWrapper weight={4} usePadding>
        <Title size="h5" color={COLORS.dark3}>
          Configurações da impressão
        </Title>
      </SeparatorWrapper>

      <PdfBasicOptionsForm />
      <Separator weight={4} />
    </Sticky>
  )
}

export default OptionsForm
